/**
 * Carousel functionality
 */

const seeMore = function() {
  const slides = document.querySelectorAll(".lp__background-item");

  // Create dynamic pagination.
  const pagination = document.querySelector(".lp__background-pagination");

  slides.forEach( (_, i) => {
    const bullet = (i == slides.length -1) ? "<span class='active'></span>" : "<span></span>";
    pagination.insertAdjacentHTML("afterbegin", bullet);
  });

  // For pagination bullet functionality
  const bullets = document.querySelectorAll(".lp__background-pagination span");

  const changeActive = function() {
    bullets.forEach((item, i) => {
      if ( i == curr ) {
        item.classList.add("active");
      } else {
        item.classList.remove("active");
      };
    });
  };

  // Carousel Arrow Functionality
  const prevBtn = document.querySelector(".js-prev-btn");
  const nextBtn = document.querySelector(".js-next-btn");
  const list = document.querySelector(".lp__background-list");
  let curr = 0;

  nextBtn.addEventListener("click", function() {
    curr = curr < slides.length - 1 ? ++curr : 0;
    list.style.transform = `translateX(${100 * -(curr)}%)`;
    changeActive();
  });

  prevBtn.addEventListener("click", function() {
    curr = curr > 0 ? --curr : slides.length - 1;
    list.style.transform = `translateX(${100 * -(curr)}%)`;
    changeActive();
  });
};

export default seeMore;